export const Languages = {
    EN: 'en',
    EL: 'el',
    HR: 'hr',
    BG: 'bg',
} as const;

export type Language = typeof Languages[keyof typeof Languages];
